import CheckRender from "../../../components/Common/CheckRender";
import CustomAlert from "../../../components/Common/CustomAlert";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Text from "../../../components/Common/Text";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";

const ValidacionesModals = ({
  showCoberturasRequeridasAlert,
  onCloseCoberturasRequeridas,
  showResultadoEnvioModal,
  resultadoEnvio,
  onVolverIngresos,
  onIrADetalles,
  showConfirmarEliminarCobertura,
  onConfirmarEliminarCobertura,
  onCancelarEliminarCobertura,
  showConfirmarEliminarAnexo,
  onConfirmarEliminarAnexo,
  onCancelarEliminarAnexo,
  showCoberturasDuplicadasModal,
  coberturasDuplicadas,
  onCerrarCoberturasDuplicadas,
  showUploadResultsModal,
  uploadedFilesResults,
  onCloseUploadResults,
  showModalEncuestaSatisfaccion,
  onResponderEncuesta,
  showCirugiasLiberadasModal,
  cirugiasLiberadasData,
  onCerrarCirugiasLiberadas,
  showConfirmarEnvioCoberturas,
  onConfirmarEnvioCoberturas,
  onCancelarEnvioCoberturas,
  showModalEncuestaCes,
  showEncuestaCesIframe,
  onResponderEncuestaCes,
  onCerrarEncuestaCesIframe,
  onCerrarResultadoEnvio,
}) => {
  return (
    <>
      <CheckRender allowed={showCoberturasRequeridasAlert}>
        <CustomAlert
          type="warning"
          title="Coberturas requeridas"
          message="Debe agregar al menos una cobertura antes de poder enviar la solicitud. Utilice el botón 'Agregar cobertura' para incluir las coberturas necesarias."
          onConfirm={onCloseCoberturasRequeridas}
          confirmText="Entendido"
          maxWidth="500px"
        />
      </CheckRender>

      <CheckRender allowed={showResultadoEnvioModal}>
        <CustomAlert
          type={resultadoEnvio?.tipo || "info"}
          title={resultadoEnvio?.titulo || "Resultado del envío"}
          message={resultadoEnvio?.mensaje || ""}
          onConfirm={
            resultadoEnvio?.tipo === "success" && !!onIrADetalles
              ? onIrADetalles
              : resultadoEnvio?.tipo === "error" && onCerrarResultadoEnvio
              ? onCerrarResultadoEnvio
              : onVolverIngresos
          }
          confirmText={
            resultadoEnvio?.tipo === "success" && !!onIrADetalles
              ? "Ir"
              : resultadoEnvio?.tipo === "error"
              ? "Entendido"
              : "Volver a ingresos"
          }
          showSecondaryButton={resultadoEnvio?.tipo === "success" && !!onIrADetalles}
          secondaryButtonLabel="Volver a ingresos"
          onSecondaryButtonClick={onVolverIngresos}
          maxWidth="600px"
        />
      </CheckRender>

      <CheckRender allowed={showConfirmarEliminarCobertura}>
        <CustomAlert
          type="confirm"
          title="Confirmar eliminación"
          message="¿Está seguro que desea eliminar esta cobertura? Esta acción no se puede deshacer."
          onConfirm={onConfirmarEliminarCobertura}
          onCancel={onCancelarEliminarCobertura}
          confirmText="Sí, eliminar"
          cancelText="Cancelar"
          maxWidth="500px"
        />
      </CheckRender>

      <CheckRender allowed={showConfirmarEliminarAnexo}>
        <CustomAlert
          type="confirm"
          title="Confirmar eliminación"
          message="¿Está seguro que desea eliminar este anexo? Esta acción no se puede deshacer."
          onConfirm={onConfirmarEliminarAnexo}
          onCancel={onCancelarEliminarAnexo}
          confirmText="Sí, eliminar"
          cancelText="Cancelar"
          maxWidth="500px"
        />
      </CheckRender>

      <CheckRender
        allowed={
          showCoberturasDuplicadasModal &&
          coberturasDuplicadas &&
          coberturasDuplicadas.length > 0
        }
      >
        <CustomAlert
          type="warning"
          title="Coberturas ya agregadas"
          message={`Las siguientes coberturas ya han sido agregadas anteriormente:`}
          onConfirm={onCerrarCoberturasDuplicadas}
          confirmText="Entendido"
          maxWidth="600px"
        >
          <div style={{ marginTop: "16px", textAlign: "left" }}>
            <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
              {coberturasDuplicadas.map((cobertura, index) => (
                <li key={index} style={{ marginBottom: "8px" }}>
                  <Text size="15px" margin="0">
                    {cobertura.codigoCobertura || "N/A"}
                    {cobertura.nombreCobertura && (
                      <> - {cobertura.nombreCobertura}</>
                    )}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        </CustomAlert>
      </CheckRender>

      <CheckRender allowed={showUploadResultsModal}>
        <CustomModal
          isOpen={showUploadResultsModal}
          onClose={onCloseUploadResults}
        >
          <Section style={{ padding: "20px" }}>
            <Text
              size="18px"
              weight="bold"
              color="#ff4d4f"
              style={{ marginBottom: "15px" }}
            >
              ⚠️ Errores al subir archivos
            </Text>

            {uploadedFilesResults
              ?.filter((result) => !result.exito)
              .map((result, index) => (
                <Section
                  key={index}
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    backgroundColor: "#fff2f0",
                    border: "1px solid #ffccc7",
                    borderRadius: "4px",
                  }}
                >
                  <Text size="14px" weight="bold" color="#ff4d4f">
                    📄 {result.archivo?.name || "Archivo desconocido"}
                  </Text>
                  <Text size="12px" color="#666" style={{ marginTop: "5px" }}>
                    Error: {result.errorMessage}
                  </Text>
                  {result.errorResponse && (
                    <Text size="11px" color="#999" style={{ marginTop: "3px" }}>
                      Detalles: {JSON.stringify(result.errorResponse)}
                    </Text>
                  )}
                </Section>
              ))}

            {uploadedFilesResults
              ?.filter((result) => result.exito && !result.anexo?.exito)
              .map((result, index) => (
                <Section
                  key={`anexo-error-${index}`}
                  style={{
                    marginBottom: "10px",
                    padding: "10px",
                    backgroundColor: "#fff7e6",
                    border: "1px solid #ffd591",
                    borderRadius: "4px",
                  }}
                >
                  <Text size="14px" weight="bold" color="#fa8c16">
                    📎 Error al registrar anexo:{" "}
                    {result.archivo?.name || "Archivo desconocido"}
                  </Text>
                  <Text size="12px" color="#666" style={{ marginTop: "5px" }}>
                    Error:{" "}
                    {result.anexo?.error ||
                      "Error desconocido al registrar anexo"}
                  </Text>
                </Section>
              ))}

            <Section style={{ marginTop: "20px", textAlign: "center" }}>
              <CustomButton
                label="Cerrar"
                onClick={onCloseUploadResults}
                width="100px"
                height="35px"
              />
            </Section>
          </Section>
        </CustomModal>
      </CheckRender>

      <CheckRender allowed={showModalEncuestaSatisfaccion}>
        <CustomModal
          isOpen={showModalEncuestaSatisfaccion}
          onClose={() => onResponderEncuesta("No")}
          maxWidth="500px"
        >
          <Section
            flexDirection="column"
            style={{ padding: "20px", textAlign: "center" }}
          >
            <Text size="18px" weight="bold" style={{ marginBottom: "20px" }}>
              ¿Desea llenar una encuesta de satisfacción para calificar su experiencia en la plataforma?
            </Text>

            <CustomSeparator height="20px" />

            <Section
              flexDirection="row"
              align="center"
              justify="center"
              width="100%"
              gap="15px"
            >
              <CustomButton
                label="Sí"
                onClick={() => onResponderEncuesta("Sí")}
                width="100px"
                height="40px"
              />
              <CustomButton
                label="No"
                onClick={() => onResponderEncuesta("No")}
                width="100px"
                height="40px"
                bgColor="#6c757d"
                hoverColor="#5a6268"
              />
            </Section>
          </Section>
        </CustomModal>
      </CheckRender>

      <CheckRender allowed={showCirugiasLiberadasModal && cirugiasLiberadasData}>
        <CustomAlert
          type="info"
          title="Cirugías liberadas"
          message={cirugiasLiberadasData?.mensaje || ""}
          onConfirm={cirugiasLiberadasData?.onConfirm || onCerrarCirugiasLiberadas}
          confirmText="Entendido"
          maxWidth="600px"
        >
          {cirugiasLiberadasData?.nombresCoberturas && cirugiasLiberadasData.nombresCoberturas.length > 0 && (
            <div style={{ marginTop: "16px", textAlign: "left" }}>
              <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                {cirugiasLiberadasData.nombresCoberturas.map((nombre, index) => (
                  <li key={index} style={{ marginBottom: "8px" }}>
                    <Text size="15px" margin="0">
                      {nombre}
                    </Text>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </CustomAlert>
      </CheckRender>

      <CheckRender allowed={showConfirmarEnvioCoberturas}>
        <CustomAlert
          type="confirm"
          title="Confirmar envío"
          message="¿Está seguro que desea enviar las coberturas? Esta acción procesará las coberturas para su validación."
          onConfirm={onConfirmarEnvioCoberturas}
          onCancel={onCancelarEnvioCoberturas}
          confirmText="Sí, enviar"
          cancelText="Cancelar"
          maxWidth="500px"
        />
      </CheckRender>

      <CheckRender allowed={showModalEncuestaCes}>
        <CustomModal
          isOpen={showModalEncuestaCes}
          onClose={() => showEncuestaCesIframe ? onCerrarEncuestaCesIframe() : onResponderEncuestaCes("No")}
          maxWidth={showEncuestaCesIframe ? "90vw" : "500px"}
        >
          {showEncuestaCesIframe ? (
            <Section
              flexDirection="column"
              style={{
                padding: "20px",
                width: "min(90vw, 1200px)",
                minWidth: "800px",
                height: "80vh",
                minHeight: "700px",
                maxHeight: "85vh",
                display: "flex",
                alignItems: "stretch",
                justifyContent: "flex-start",
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <Text
                size="18px"
                weight="bold"
                style={{
                  marginBottom: "16px",
                  textAlign: "center",
                  width: "100%",
                  flexShrink: 0,
                }}
              >
                Encuesta CES
              </Text>
              <iframe
                src="https://hsrd.typeform.com/cespxvq"
                style={{
                  flex: 1,
                  width: "100%",
                  minHeight: 0,
                  border: "none",
                  borderRadius: "4px",
                  backgroundColor: "white",
                  display: "block",
                }}
                title="Encuesta CES"
              />
              <Section
                style={{
                  marginTop: "16px",
                  textAlign: "center",
                  width: "100%",
                  flexShrink: 0,
                }}
              >
                <CustomButton
                  label="Cerrar"
                  onClick={onCerrarEncuestaCesIframe}
                  width="100px"
                  height="40px"
                />
              </Section>
            </Section>
          ) : (
            <Section
              flexDirection="column"
              style={{ padding: "20px", textAlign: "center" }}
            >
              <Text size="18px" weight="bold" style={{ marginBottom: "20px" }}>
                ¿Quiere llenar la encuesta CES?
              </Text>

              <CustomSeparator height="20px" />

              <Section
                flexDirection="row"
                align="center"
                justify="center"
                width="100%"
                gap="15px"
              >
                <CustomButton
                  label="Sí"
                  onClick={() => onResponderEncuestaCes("Sí")}
                  width="100px"
                  height="40px"
                />
                <CustomButton
                  label="No"
                  onClick={() => onResponderEncuestaCes("No")}
                  width="100px"
                  height="40px"
                  bgColor="#6c757d"
                  hoverColor="#5a6268"
                />
              </Section>
            </Section>
          )}
        </CustomModal>
      </CheckRender>
    </>
  );
};

export default ValidacionesModals;

